export const questions = {
  "eligibilityQuestions": {
    "Fund of funds": [
      {
        "id": 1,
        "text": "Alternative Investment Fund (AIF) registered with Securities Exchange Board of India (SEBI) as: (Tick the right choice)",
        "options": [{ "id": 1, "text":"Category I" }, { "id": 1, "text":"Category II" }, { "id": 1, "text":"Category III" }],
        "elibibleOptions": ["Category I", "Category II"]
      },
      {
        "id": 2,
        "text": "Does your Alternative Investment Fund (AIF) invest in securities of Companies or Funds incorporated and operated outside India in violation of Section 25 of the PFRDA Act, 2013?",
        "elibibleOptions": ["no"]
      },
      {
        "id": 3,
        "text": "What is the intended target size for the fund?",
        "options": [{ "id": 1, "text":"Less than ₹ 100 cr " }, { "id": 1, "text":"Equal or More than ₹100 cr" }],
        "elibibleOptions": ["Equal or More than ₹100 cr"]
      },
      {
        "id": 4,
        "text": "Are the CIBIL scores of all key members* of the Fund above 700? (*Key members are defined as Directors/Partners.)",
        "elibibleOptions": ["yes"]
      },
      {
        "id": 5,
        "text": "Are all key members* legally eligible to be appointed as a director or to hold a managerial position under Indian law? (*Key members are defined as Directors/Partners.)",
        "elibibleOptions": ["yes"]
      },
      {
        "id": 6,
        "text": "Do any of the key members* have any pending proceedings, investigations, or cases under Indian Laws relating to money laundering, including under the Prevention of Money Laundering Act, 2002 (PMLA)? (*Key members are defined as Sponsor, Directors/Partners.)",
        "elibibleOptions": ["no"]
      }
    ]
  }
}



